import React from 'react';
import photo from './img/av.jpg';

export const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="title">
            <h1>Kiril Novytskyi</h1>
            <p><i>Front-End Developer</i></p>
          </div>
          <div className="header-photo">
            <img
              src={photo}
              alt="Kiril"
            />
          </div>
        </div>
      </div>
    </header>
  );
};
